'use strict';

function setTransactionOptions(transaction, options) {
  const { nameToOverwrite, tags } = options;
  if (nameToOverwrite) {
    transaction.setName(nameToOverwrite);
  }
  if (tags) {
    Object.entries(tags).forEach(([key, value]) => {
      transaction.setTag(key, value);
    });
  }
}

exports.setTransactionOptions = setTransactionOptions;
//# sourceMappingURL=transactionOptions.cjs.map
